import { contentfulClient } from '@/common/lib/contentfulClient';
import * as Sentry from '@sentry/nextjs';

const GET_PAGE_BY_ID_QUERY = `
  query GetPageById($id: String!) {
    page(id: $id) {
      _id
      slug
    }
  }
`;

export async function getPageById(id: string) {
  try {
    const result = await contentfulClient('', {
      method: 'POST',
      body: JSON.stringify({
        query: GET_PAGE_BY_ID_QUERY,
        variables: { id },
      }),
    });

    return result.data?.page;
  } catch (error) {
    Sentry.captureException(error);
    console.warn('Error fetching page by ID:', error);
    return null;
  }
}
